import $ from 'jquery'
import CONFIG_API, { FRONT_PAGE_EXTEND } from './../../config/config.default.js';

export const SET_OBJAPI = 'SET_OBJAPI'; // 设置配置信息
export const SET_INDEX_TITLE = 'SET_INDEX_TITLE';
export const GET_ROOT_PATH = 'GET_ROOT_PATH'; // 根据当前访问路径获取根路径
export const GET_CONFIG_INFO = 'GET_CONFIG_INFO'; // 获取配置信息
export const SET_CONFIG_PATH = 'SET_CONFIG_PATH'; // 设置请求api地址
export const GET_SYSTEM_CONFIG = 'GET_SYSTEM_CONFIG'; // 获取系统配置

console.log(process.env)

const api = {
  state: null,
  mutations: {
    [SET_OBJAPI](state, config) {
      Object.assign(state, config);
    },
    [SET_INDEX_TITLE](state, title) {
      state.indexTitle = title;
    }
  },
  actions: {
    // 设置配置信息
    async [SET_OBJAPI]({ dispatch, commit }) {
      try {
        if (process.env.NODE_ENV === 'development') {
          commit(SET_OBJAPI, CONFIG_API);
          return CONFIG_API;
        } else {
          const ori = getOrigin();
          const rootPath = await dispatch(GET_ROOT_PATH);
          // 项目初始路径
          const api = `${ori}/${rootPath}/`;
          const config = await dispatch(GET_CONFIG_INFO, api);
          dispatch(SET_CONFIG_PATH, config);
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    // 获取根路径信息
    async [GET_ROOT_PATH]() {
      const [, rootPath = ''] = window.location.pathname.split('/');
      return rootPath || process.env.PUBLICPATH;
    },
    // 获取配置信息
    [GET_CONFIG_INFO]({ dispatch }, api) {
      return new Promise(resolve => {
        // 先获取后台配置
        $.get(`${api}config`, res => {
          // 获取前端系统配置
          dispatch(GET_SYSTEM_CONFIG, api).then(system => {
            const data = Object.assign(res, system);
            resolve(data);
          })
        });
      });
    },
    // 获取系统配置
    [GET_SYSTEM_CONFIG]({}, api) {
      return new Promise(resolve => {
        const url = `${api}${FRONT_PAGE_EXTEND}`;
        $.get(url, res => {
          resolve(res);
        });
      });
    },
    // 设置配置信息
    async [SET_CONFIG_PATH]({ dispatch, commit }, data) {
      const ori = getOrigin();
      const rootPath = await dispatch(GET_ROOT_PATH);
      const currAPIURL = `${ori}/${rootPath}/`; // 动态获取API地址
      console.log('herong',data)
      const {
        serviceUrl, // 客服系统地址
        platformName, // 浏览器标签页title显示
        showCode, // 登录时是否显示验证码
        version,
        passwordEncoder,
        rule = '',
        nodeId = '',
        otherConfig = '',
        dpw = '' // 默认密码
      } = data;
      const config = {
        BASE_API: currAPIURL,
        OAUTH_API: currAPIURL,
        LOCAL_URL: `${currAPIURL}fe`,
        UPLOAD_API: `${currAPIURL}manage/pub/uploadFile`,
        IMPORT_API: currAPIURL,
        SERVICE_API: serviceUrl,
        PLATFORM_NAME: platformName,
        NODE_ID: nodeId,
        otherConfig,
        rule,
        showCode: showCode,
        VERSION: version,
        passwordEncryption: passwordEncoder,
        DEFAULT_PW: dpw // 默认密码
      };
      commit(SET_OBJAPI, config);
      return config;
    }
  }
};

// 解决IE不识别window.location.origin
export function getOrigin() {
  let origin = '';
  if (!window.location.origin) {
    origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  } else {
    origin = window.location.origin;
  }
  return origin;
}

export default api



// WEBPACK FOOTER //
// ./src/store/modules/api.js